import { colors } from "./variables"

export default {
  DARK: { backgroundColor: colors.Jet, color: colors.Isabelline },
  ORANGE: {
    backgroundColor: colors.PortlandOrange,
    color: colors.Isabelline,
  },
  LIGHT: { backgroundColor: colors.Isabelline, color: colors.Jet },
}
